import {Routes} from '@angular/router';
import {JbConfigPagePage} from './page/jb-config-page/jb-config-page.page';
import {JobDashboardPage} from './page/job-dashboard-page/job-dashboard.page';
import {
    JbJobGroupBatchOverviewComponent
} from './component/protected-components/jb-job-group-batch-overview-component/jb-job-group-batch-overview.component';
import {
    JbSingleJobBatchOverviewComponent
} from './component/protected-components/jb-single-job-batch-overview-component/jb-single-job-batch-overview.component';
import {
    JbJobBatchStatsComponent
} from './component/protected-components/jb-job-batch-stats/jb-job-batch-stats.component';
import {
    JbJobExecutionOverlapComponent
} from './component/protected-components/jb-job-execution-overlap-component/jb-job-execution-overlap.component';
import {
    JbJobTypeDashboardComponent
} from './component/protected-components/jb-job-type-dashboard-component/jb-job-type-dashboard.component';
import {
    JbJobRunDashboardComponent
} from './component/protected-components/jb-job-run-dashboard-component/jb-job-run-dashboard.component';
import {
    JbDashboardOverviewComponent
} from './component/protected-components/jb-dashboard-overview-component/jb-dashboard-overview.component';
import {
    JbThreadAnalysisComponent
} from './component/protected-components/jb-thread-analysis-component/jb-thread-analysis.component';

export function JbSubRoutes(): Routes {

    /**
     *
     * path:
     * Prefix of the module will always be added to the path name
     *
     *      Example
     *      path: 'addresses' => route path 'ad/addresses' !
     * ------------------------------------------------------------------
     *
     * canActivate:
     * The authentication guard MsalGuard will be added automatically!
     * ------------------------------------------------------------------
     *
     * component:
     * Added components need to be from type 'Page'!
     * ------------------------------------------------------------------
     *
     */
    const routes = [

        {
            path: 'jb/config',
            component: JbConfigPagePage
        },
        {
            path: 'jb/dashboard',
            component: JobDashboardPage,
            children: [
                {
                    path: '',
                    component: JbDashboardOverviewComponent,
                },
                {
                    path: 'jobs',
                    component: JbJobTypeDashboardComponent,
                },
                {
                    path: 'runs',
                    component: JbJobRunDashboardComponent,
                },
                {
                    path: 'spring-batch',
                    component: JbJobGroupBatchOverviewComponent,
                },
                {
                    path: 'job/:jobId',
                    component: JbSingleJobBatchOverviewComponent,
                },
                {
                    path: 'stat/:status',
                    component: JbJobBatchStatsComponent,
                },
                {
                    path: 'overlap',
                    component: JbJobExecutionOverlapComponent
                },
                {
                    path: 'thread-analysis',
                    component: JbThreadAnalysisComponent
                }
            ]
        }
    ];

    return routes;

}
